import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { Check, Delete, Edit } from '@material-ui/icons';
import { SmallIconButton } from '../../../common';

interface ActionButtonsProps {
    isEditing?: boolean;
    onEdit?: () => void;
    onConfirm?: () => void;
    onDelete?: () => void;
}

const ActionButtons = ({ isEditing, onEdit, onConfirm, onDelete }: ActionButtonsProps) => {
    const { t } = useTranslation();

    const editTooltipTitle = t('Edit');
    const confirmTooltipTitle = t('Confirm');
    const deleteTooltipTitle = t('Delete');

    const actions = isEditing
        ? (
            <SmallIconButton onClick={onConfirm} IconComponent={Check} tooltip={confirmTooltipTitle} />
        )
        : (
            <>
                <SmallIconButton onClick={onEdit} IconComponent={Edit} tooltip={editTooltipTitle} />
                <SmallIconButton onClick={onDelete} IconComponent={Delete} tooltip={deleteTooltipTitle} />
            </>
        );

    return (
        <Box display='flex' alignItems='center'>
            {actions}
        </Box>
    );
};

export default ActionButtons;
